import { render } from "./DiabeticClinicPage.vue?vue&type=template&id=ebe3daca"
import script from "./DiabeticClinicPage.vue?vue&type=script&lang=js"
export * from "./DiabeticClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__